import React from 'react';
import { availableLanguages } from '../i18n';
import { getFlag } from './Flags';

export default function Header({ t, lang, setLang }) {
  return (
    <div className="app-header">
      <h1>{t.title}</h1>
      <p>{t.subtitle}</p>
      <div className="lang-switcher">
        {availableLanguages.map(({ code, label }) => {
          const Flag = getFlag(code);
          return (
            <button
              key={code}
              onClick={() => { setLang(code); localStorage.setItem('rpm_lang', code); }}
              className={`lang-switch ${lang === code ? 'active' : ''}`}
              title={label}
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              {Flag && <Flag />}
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
